import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";



const slice = createSlice({
  name:'auth',
  initialState:{
    user: '',
    loading: false,
    token : '',
  },
  reducers:{
    setUser:(auth,action)=>{
      auth.user = action.payload.original.user;
      auth.token = action.payload.original.access_token;
      auth.loading = false;
      // sessionStorage.setItem('token',JSON.stringify(auth.token));
      // sessionStorage.setItem('user',JSON.stringify(auth.user));
    },
    logoutUser:(auth,action)=>{
      localStorage.clear(); 
      auth.user = "";
      auth.token = "";
    },
    setLoading: (auth,action)=>{
      auth.loading = action.payload;
    }
    
  }
})


// export const getToken = () =>{
//   const tokenString = sessionStorage.getItem('token');
//   const userToken = JSON.parse(tokenString);
//   return userToken;
// }

export const getUser = () =>{
  const userString = sessionStorage.getItem('user');
  const user_detail = JSON.parse(userString);
  return user_detail;
}
// console.log(slice);logoutUser
export const {setUser, logoutUser,setLoading,getToken } = slice.actions;
export default slice.reducer;

//Action Creators
export const loginAction = (data) => apiCallBegan({
  url:`/login`,
  method:"post",
  data:data,
  onSuccess:setUser
})

//Action Creators
export const registerAction = (data) => apiCallBegan({
  url:`/register`,
  method:"post",
  data:data
})

export const logoutAction = (id,token) => apiCallBegan({
  url:`/logout`,
  method:"post",
  onSuccess:logoutUser,
  token:token
})
